/**
 *
 * Image Overlay
 *
 * Over UI for animating the image effect for hero images
 */

const $ = require( 'jquery' );

var ImgOverlay = function(el){

  this.$el      = $(el);
  this.$img      = this.$el.find('img:first');
  this.$excerpt    = this.$el.find('.js-image-overlay__excerpt');
  this.$overlay    = $('<div />').addClass('js-image-overlay__overlay');

  this.$el.append( this.$overlay );

  this.waypoint  = null;

  this.init();
};

ImgOverlay.prototype.init = function(){

  //if there is no intersection observer in browser, then play animation
  if (!'IntersectionObserver' in window){

    this.handleAnimation();
    return;
  }

  //config
  const config = {
    rootMargin: '0px 0px -20% 0px',
  };

  //setup intersection observer instance
  let observer = new IntersectionObserver( (entries)=> {
    entries.forEach(entry => {

      //if we are intersecting then play animation
      if( entry.isIntersecting ){

        this.handleAnimation();

        observer.unobserve( entry.target );

      }

    });
  }, config);

  this.$el.get().forEach(img => {
    observer.observe(img);
  });

};

ImgOverlay.prototype.handleAnimation = function(){

  let tl  = new TimelineMax()
    .addLabel('image/overlay')
    .to( this.$overlay, .7, { left :'105%', ease: Power1.easeInOut }, 'image/overlay' )
    .to( this.$img, 1, { autoAlpha : 1, scale : 1, transformOrigin:"50% 50%", ease: Power1.easeInOut }, 'image/overlay' )
    .to( this.$el, .5 , {backgroundColor: 'transparent'}, 'image/overlay' );

  if( this.$excerpt.length ){
    // 'image/overlay-=.2'
    tl.to( this.$excerpt, .25, { y: 0, autoAlpha : 1 } );
  }

};

ImgOverlay.prototype.getScrollParent = function(element, includeHidden) {
  var style = getComputedStyle(element);
  var excludeStaticParent = style.position === "absolute";
  var overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/;

  if (style.position === "fixed") return document.body;
  for (var parent = element; (parent = parent.parentElement);) {
    style = getComputedStyle(parent);
    if (excludeStaticParent && style.position === "static") {
      continue;
    }
    if (overflowRegex.test(style.overflow + style.overflowY + style.overflowX)) return parent;
  }

  return document.body;
};

$(document)
  .on( 'ajaxInit', function(){

    $('.js-image-overlay').each(function(){
      new ImgOverlay(this);
    });
  } )
  .ready(function(){

  $('.js-image-overlay').each(function(){
    new ImgOverlay(this);
  });

});
